export const narusDarkBlue = '#074BA3'
export const narusBlue = '#2F7DE1'
export const narusGreen = '#6CC049'
export const narusOrange = '#FA8D29'
export const narusPurple = '#B096DA'
export const narusYellow = '#FFD600'
export const narusTeal = '#00ACC8'
export const narusRed = '#FF5741'
export const narusGrey1 = '#F9F9F9'
export const narusGrey2 = '#F5F5F5'
export const narusGrey3 = '#EEE'
export const narusGrey4 = '#DDD'
export const narusGrey5 = '#BBB'
export const narusGrey6 = '#AAA'
export const narusLightBlue = '#DCECF3'
